import { useEffect, useState } from "react";
import { Hero } from "../components/Hero";
import { SearchSection } from "../components/SearchSection";
import {SwalModal} from "../components/Modal";


export const HomePage = () => {
  const [isModalOpen, setModalOpen] = useState(false);

  //Funcionamiento de Modal
  

  useEffect(() => {
    // Muestra el modal automáticamente al cargar la página
    setModalOpen(true);
  }, []);


  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden"; //bloquear scroll
    } else {
      document.body.style.overflow = "auto"; //restaurar el scroll
    }

    return () => {
      document.body.style.overflow = "auto"; //Limpieza en caso de desmontar
    };
  }, [isModalOpen]);


  return (
    <>
      <Hero />
      
      <main className="-translate-y-0 md:-translate-y-24 lg:-translate-y-0">
        <SearchSection />
        <SwalModal isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
      </main>


    </>
  );
};

